import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.css']
})
export class TutorialComponent implements OnInit {

  public SignedUp = '../../../assets/pictures/SignedUp.PNG';
  public EventDetail = '../../../assets/pictures/EventDetail.PNG'
  public EventList = '../../../assets/pictures/EventList.PNG'
  public QuestionList = '../../../assets/pictures/QuestionList.PNG'
  public WelcomePage = '../../../assets/pictures/WelcomePage.PNG'
 

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/tutorial/tutorial.component.ts